/* Léger basculement 3D qui suit la souris (cartes produits et tuiles de collections), comme l'éventail de l'accueil. */
(() => {
  if (window.DbTilt) return;
  window.DbTilt = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTOR = '.db-card__media, .db-tile';
  const MAX = 7; // degrés
  let current = null;
  let frame = null;

  const reset = (el) => {
    el.classList.remove('is-tilting');
    el.style.removeProperty('--db-tilt-x');
    el.style.removeProperty('--db-tilt-y');
  };

  document.addEventListener('pointermove', (event) => {
    const el = event.target.closest(SELECTOR);
    if (current && current !== el) reset(current);
    current = el;
    if (!el) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      el.classList.add('is-tilting');
      el.style.setProperty('--db-tilt-x', `${((0.5 - y) * MAX).toFixed(2)}deg`);
      el.style.setProperty('--db-tilt-y', `${((x - 0.5) * MAX).toFixed(2)}deg`);
      el.style.setProperty('--db-glare-x', `${(x * 100).toFixed(1)}%`);
      el.style.setProperty('--db-glare-y', `${(y * 100).toFixed(1)}%`);
    });
  });

  document.addEventListener('pointerleave', () => current && reset(current));
})();
